import React, { useEffect, useState } from "react";
import { IoIosArrowForward } from "react-icons/io";
import { BsPlusSquareFill } from "react-icons/bs";
import { CiCircleMinus, CiCirclePlus } from "react-icons/ci";
import { Link } from "react-router-dom";
import {
  ChangeTitle,
  formatPrice,
  selectFormStyle,
  selectStyle,
  toAbsoluteUrl,
  toasterrormsg,
  toastsuccessmsg,
} from "../../helpers/Reusable";
import { ToastContainer } from "react-toastify";
import ClipLoader from "react-spinners/ClipLoader";
import {
  apiHeader,
  deleteData,
  getData,
  postData,
} from "../../helpers/ApiHelper";
import { getCookie, setCookie } from "../../helpers/CookieComponent";
import Select from "react-select";

const BooksViewCart = () => {
  ChangeTitle("View Cart");
  const planbillingId = getCookie("b-planbillingId");
  const currency = getCookie("b-plan-currency");
  const currencySymbol = getCookie("a-plan-currency-s");
  const [currencyList, setCurrencyList] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(currency || "INR");
  const [bookCartList, setBookCartList] = useState([]);
  const [bookCartPreview, setBookCartPreview] = useState({});

  // Initialize quantities state with bookCartList data
  const [quantities, setQuantities] = useState({});

  // Populate quantities from bookCartList on mount
  useEffect(() => {
    const initialQuantities = {};
    bookCartList.forEach((data) => {
      initialQuantities[data._id] = data.book.quantity; // Assuming each item has a `quantity` property
    });
    setQuantities(initialQuantities);
  }, [bookCartList]);

  // Function to get the current quantity for a book
  const getQuantity = (bookId) => quantities[bookId] || 0;

  // Function to handle incrementing quantity
  const incrementQuantity = async (bookId) => {
    const newQuantity = getQuantity(bookId) + 1; // Calculate the new quantity
    setQuantities((prev) => ({
      ...prev,
      [bookId]: newQuantity,
    }));

    // Call the API with the updated quantity
    await editBookCartList(bookId, newQuantity);
  };

  // Function to handle decrementing quantity
  const decrementQuantity = async (bookId) => {
    const newQuantity = Math.max(1, getQuantity(bookId) - 1); // Ensure quantity doesn't go below 0
    setQuantities((prev) => ({
      ...prev,
      [bookId]: newQuantity,
    }));

    // Call the API with the updated quantity
    await editBookCartList(bookId, newQuantity);
  };

  useEffect(() => {
    if (currency) {
      setSelectedCountry(currency);
    }
  }, [currency]);

  // Currency API Call
  const viewCurrencyList = async () => {
    const param = {};
    var response = await postData("currency/list", param, apiHeader(false));

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      const currencyData = data.map((data) => {
        return {
          id: data._id,
          value: data.countryDetail.currency,
          label: `${data.countryDetail.currencyName} (${data.countryDetail.currencySymbol}) - ${data.countryDetail.currency}`,
          currencySymbol: data.countryDetail.currencySymbol,
          currency: data.countryDetail.currency,
        };
      });
      setCurrencyList(currencyData);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  // Edit Cart API Call
  const editBookCartList = async (cartId, qty) => {
    const param = {
      cartId: cartId,
      quantity: qty,
    };

    var response = await postData(
      "private/cart/edit/quantity",
      param,
      apiHeader(false)
    );

    console.log("response", response);

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      viewBookCartList(selectedCountry);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  // Remove Cart API Call
  const removeBookCart = async (cartId) => {
    const param = {
      cartId: cartId,
    };

    var response = await deleteData(
      "private/cart/delete",
      param,
      apiHeader(false)
    );

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      viewBookCartList(selectedCountry);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  // View Cart API Call
  const viewBookCartList = async (currency) => {
    const param = {
      currency: currency,
    };

    var response = await postData("private/cart/view", param, apiHeader(false));

    console.log("response", response);

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.productDetail;
      const listData = data.map((data) => {
        return data;
      });
      setBookCartList(listData);
      setBookCartPreview(response.data.data.paymentDetail);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  useEffect(() => {
    viewBookCartList(selectedCountry);
  }, [selectedCountry]);

  useEffect(() => {
    viewCurrencyList();
  }, []);

  return (
    <>
      <ToastContainer />
      <div className="w-full p-[3%] billing-address-main">
        <div className="xxl:container mx-auto">
          <div className="w-full mb-[5%] md:mb-[2%]">
            <h1 className="hanson text-center mb-[1%] heading">
              Shopping cart
            </h1>
            <img
              className="mb-[2%] mx-auto"
              src={toAbsoluteUrl("media/img/titledesign/t-yellow.svg")}
              alt=""
            />
          </div>
          <div className="flex relative z-[3] mb-[5%] justify-center items-center gap-5">
            <label className="currencylabel">Currency</label>
            <div className="w-[60%] md:w-[30%] currencyselect">
              <Select
                name="countryName"
                id="country"
                placeholder="Select country"
                className="w-full cs-main"
                isSearchable={true}
                options={currencyList}
                value={currencyList.find(
                  (item) => item.value === selectedCountry
                )}
                onChange={(e) => {
                  setSelectedCountry(e.value);
                  setCookie("b-plan-currency", e.currency, {});
                }}
                styles={selectStyle}
              />
            </div>
          </div>
          {Object.keys(bookCartPreview).length == 0 && (
            <div>
              <h1 className="mb-[3%] text-center cart-empty">
                Your shopping cart is empty
              </h1>
              <div className="text-center">
                <Link to="/books" className="btn-explore">
                  Explore products!
                </Link>
              </div>
            </div>
          )}
          <div className="w-full flex flex-col lg:flex-row gap-10 address-details">
            <div className="w-full flex flex-col gap-10 lg:w-[70%] h-max">
              {bookCartList.map((data, i) => (
                <div className="w-full flex gap-10 p-[3%] sm:p-[2%] md:p-[1%] bg-white justify-between book-cart-box">
                  <div className="flex gap-10 w-[80%]">
                    <div className="w-[10rem] h-[10rem]">
                      <img
                        className="w-full"
                        src={data.book.bookImage}
                        alt=""
                      />
                    </div>
                    <div className="w-[80%]">
                      <h1 className="mb-[1rem] sbp2-box-title">
                        {data.book.title}
                      </h1>
                      <h1 className="mb-[2rem] sbp2-box-price">
                        {data.currency} {formatPrice(data.book.price, data.currency)}
                      </h1>
                      <div className="flex items-center gap-10 csb1">
                        <CiCircleMinus
                          onClick={() => decrementQuantity(data._id)}
                          className="cursor-pointer csb1-icon"
                        />
                        <h3
                          style={{ userSelect: "none" }}
                          className="quantity csb1-no"
                        >
                          {getQuantity(data._id)}
                        </h3>
                        <CiCirclePlus
                          onClick={() => incrementQuantity(data._id)}
                          className="cursor-pointer csb1-icon"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="w-[10%] flex justify-end items-start">
                    <button
                      onClick={() => removeBookCart(data._id)}
                      className="cursor-pointer"
                    >
                      <img
                        className="p-[1rem] w-max mr-[2%] cursor-pointer"
                        src={toAbsoluteUrl("media/img/icon/basic/trash.svg")}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              ))}
            </div>
            {Object.keys(bookCartPreview).length > 0 && (
              <div className="h-max w-[90%] sm:w-[60%] lg:w-[30%] mx-auto p-[3%] sm:px-[2%] sm:py-[2.5%] lg:px-[1%] lg:py-[1.5%] cart-summary">
                <h1 className="w-full mb-[2%] cs-h1">Cart summary</h1>
                <div className="w-full flex flex-col justify-between">
                  <div className="w-full px-[3%] mb-[40%] py-[3.5%]"></div>
                  <div className="w-full flex flex-col items-between cs-box2">
                    <div className="mb-auto">
                      <div className="w-full flex items-center justify-between mb-[5%] gap-5 csb2">
                        <h1 className="w-[60%] sm:w-[50%] md:w-[40%] lg:w-[90%] xl:w-[57%] csb2-title">
                          Payment details
                        </h1>
                        <div className="w-full csb2-line"></div>
                      </div>
                      <div className="w-full mb-[2%] payment-details">
                        <div className="w-full flex justify-between pd-item">
                          <h1 className="w-max">Item</h1>
                          <h2 className="w-max">
                            {bookCartPreview && bookCartPreview.item}
                          </h2>
                        </div>
                      </div>
                      <div className="w-full mb-[2%] payment-details">
                        <div className="w-full flex justify-between pd-item">
                          <h1 className="w-max">Subtotal</h1>
                          <h2 className="w-max">
                            {/* {currencySymbol} */}
                            {bookCartPreview && bookCartPreview.currency}{" "}
                            {bookCartPreview &&
                              bookCartPreview.subTotal &&
                              formatPrice(bookCartPreview.subTotal, bookCartPreview.currency)}
                            /-
                          </h2>
                        </div>
                      </div>
                      <div className="w-full mb-[2%] payment-details">
                        <div className="w-full flex justify-between pd-item">
                          <h1 className="w-max">GST @ 18%</h1>
                          <h2 className="w-max">
                            {/* {currencySymbol} */}
                            {bookCartPreview && bookCartPreview.currency}{" "}
                            {bookCartPreview &&
                              bookCartPreview.GST &&
                              formatPrice(bookCartPreview.GST, bookCartPreview.currency)}
                            /-
                          </h2>
                        </div>
                      </div>
                      {bookCartPreview && bookCartPreview.discount && (
                        <div className="w-full mb-[2%] payment-details">
                          <div className="w-full flex justify-between pd-item">
                            <h1 className="w-max">Discount</h1>
                            <h2 className="w-max">
                              {/* {currencySymbol} */}
                              {bookCartPreview && bookCartPreview.currency}{" "}
                              {bookCartPreview &&
                                bookCartPreview.discount &&
                                formatPrice(bookCartPreview.discount, bookCartPreview.currency)}
                              /-
                            </h2>
                          </div>
                        </div>
                      )}
                      <div className="w-full mb-[5%] payment-details">
                        <div className="w-full flex justify-between pd-item pd-item2">
                          <h1 className="w-max">Grand total</h1>
                          <h2 className="w-max">
                            {/* {currencySymbol} */}
                            {bookCartPreview && bookCartPreview.currency}{" "}
                            {bookCartPreview &&
                              bookCartPreview.grandTotal &&
                              formatPrice(bookCartPreview.grandTotal, bookCartPreview.currency)}
                            /-
                          </h2>
                        </div>
                      </div>
                    </div>
                    <Link to="/books/cartbilling">
                    <div className="w-full flex pay-button">
                      <button  className="w-full py-[5%] btn-pay">
                        Process to pay
                      </button>
                    </div>
                    </Link>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default BooksViewCart;
